(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  // Header turns solid once you scroll past the hero edge
  const hdr = $('.hdr');
  if (hdr) {
    const always = hdr.dataset.solid === 'true';
    const onScroll = () => hdr.classList.toggle('is-solid', always || window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Hero video: fade in over the poster once frames are actually playing
  const heroVideo = $('[data-hero-video]');
  if (heroVideo) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) heroVideo.pause();
    else {
      const show = () => heroVideo.closest('.hero').classList.add('is-playing');
      heroVideo.addEventListener('playing', show, { once: true });
      if (!heroVideo.paused && heroVideo.readyState > 2) show();
    }
  }

  // Mobile drawer
  const drawer = $('#drawer');
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
  $$('[data-drawer-close], #drawer a').forEach(b => b.addEventListener('click', () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }));

  // Reveal on scroll
  const io = 'IntersectionObserver' in window && new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' });
  $$('.rv').forEach(el => io ? io.observe(el) : el.classList.add('in'));

  // Before / after sliders — a transparent range input drives the clip so it works with mouse, touch and keyboard
  $$('.ba').forEach(ba => {
    const input = $('input[type=range]', ba);
    const set = v => ba.style.setProperty('--pos', v + '%');
    input.addEventListener('input', () => set(input.value));
    set(input.value);
    // gentle hint animation the first time a slider is seen
    if (io) {
      const hint = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        hint.disconnect();
        let t = 0;
        const step = () => {
          t += 0.03;
          if (t > Math.PI * 2 || ba.dataset.touched) return set(input.value);
          set(50 + Math.sin(t) * 18);
          requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      hint.observe(ba);
    }
    input.addEventListener('pointerdown', () => { ba.dataset.touched = '1'; });
  });

  // Tabs for multi-look comparison sections
  $$('[data-tabs]').forEach(group => {
    const tabs = $$('[role=tab]', group);
    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(t => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        $('#' + t.getAttribute('aria-controls')).hidden = !on;
      });
    }));
  });

  // Showreel sound toggle
  $$('[data-sound]').forEach(btn => btn.addEventListener('click', () => {
    const v = $('video', btn.closest('.reel__frame'));
    v.muted = !v.muted;
    btn.textContent = v.muted ? 'Sound on' : 'Sound off';
    if (!v.muted) v.play();
  }));

  // Work grid: preview video on hover, lightbox on click
  const lb = $('#lightbox');
  const stage = lb && $('.lightbox__stage', lb);
  const embed = url => {
    const yt = url.match(/(?:youtu\.be\/|v=|shorts\/)([\w-]{11})/);
    if (yt) return `<iframe src="https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    const ig = url.match(/instagram\.com\/(?:p|reel|tv)\/([\w-]+)/);
    if (ig) return `<iframe class="ig" src="https://www.instagram.com/p/${ig[1]}/embed/" allowtransparency="true" allow="autoplay; encrypted-media" title="Instagram post"></iframe>`;
    const vm = url.match(/vimeo\.com\/(\d+)/);
    if (vm) return `<iframe src="https://player.vimeo.com/video/${vm[1]}?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    if (/\.(mp4|webm|mov)(\?|$)/i.test(url)) return `<video src="${url}" controls autoplay playsinline></video>`;
    return null;
  };
  $$('.work__item').forEach(item => {
    const v = $('video', item);
    if (v && matchMedia('(hover:hover)').matches) {
      item.addEventListener('mouseenter', () => { v.play().then(() => item.classList.add('is-playing')).catch(() => {}); });
      item.addEventListener('mouseleave', () => { v.pause(); item.classList.remove('is-playing'); });
    }
    item.addEventListener('click', e => {
      const url = item.dataset.full;
      const html = url ? embed(url) : `<img src="${item.dataset.img}" alt="">`;
      if (!html) { window.open(url, '_blank', 'noopener'); return; }
      e.preventDefault();
      stage.innerHTML = html;
      $('.lightbox__title', lb).textContent = item.dataset.title || '';
      const ext = $('.lightbox__ext', lb);
      if (ext) { ext.hidden = !/instagram\.com|youtu/.test(url || ''); ext.href = url || '#'; ext.textContent = /instagram/.test(url || '') ? 'View on Instagram \u2197' : 'Watch on YouTube \u2197'; }
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  const closeLb = () => { if (!lb) return; lb.classList.remove('is-open'); stage.innerHTML = ''; document.body.style.overflow = ''; };
  lb && lb.addEventListener('click', e => { if (e.target === lb || e.target.closest('.lightbox__close')) closeLb(); });

  // Booking: open the embedded scheduler, or fall back to the contact form with the topic preselected
  $$('[data-book]').forEach(btn => btn.addEventListener('click', e => {
    const box = $('#' + btn.dataset.book);
    if (!box) return;
    e.preventDefault();
    if (!box.dataset.loaded) { box.innerHTML = `<iframe src="${box.dataset.src}" title="Booking calendar" loading="lazy"></iframe>`; box.dataset.loaded = '1'; }
    $$('.scheduler.is-open').forEach(s => s !== box && s.classList.remove('is-open'));
    box.classList.toggle('is-open');
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  const topic = new URLSearchParams(location.search).get('topic');
  const sel = $('#ContactTopic');
  if (topic && sel) { const opt = $$('option', sel).find(o => o.value.toLowerCase().startsWith(topic.toLowerCase())); if (opt) sel.value = opt.value; }

  // Email capture popup
  const pop = $('#pop');
  if (pop) {
    const tab = $('.pop-tab');
    const KEY = 'jrtv-pop';
    const open = () => { pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); tab && tab.classList.remove('is-visible'); setTimeout(() => { const f = $('input[type=email]', pop); f && f.focus({ preventScroll: true }); }, 400); };
    const close = () => {
      pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
      if (!pop.dataset.done) { store.set(KEY, Date.now()); tab && tab.classList.add('is-visible'); }
    };
    $$('[data-pop-close]', pop).forEach(b => b.addEventListener('click', close));
    pop.addEventListener('click', e => { if (e.target === pop) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); closeLb(); } });
    tab && tab.addEventListener('click', open);
    const days = parseFloat(pop.dataset.days || '7');
    const last = +store.get(KEY) || 0;
    const subscribed = store.get(KEY + '-done');
    if (pop.dataset.success === 'true') { store.set(KEY + '-done', '1'); pop.dataset.done = '1'; open(); }
    else if (pop.dataset.test === 'true') open();
    else if (!subscribed && Date.now() - last > days * 864e5) {
      let fired = false;
      const fire = () => { if (fired) return; fired = true; open(); };
      setTimeout(fire, (+pop.dataset.delay || 6) * 1000);
      window.addEventListener('scroll', () => { if (window.scrollY > document.body.scrollHeight * 0.4) fire(); }, { passive: true });
    } else if (!subscribed) tab && tab.classList.add('is-visible');
    const copy = $('[data-copy]', pop);
    copy && copy.addEventListener('click', () => { navigator.clipboard && navigator.clipboard.writeText(copy.dataset.copy); copy.textContent = 'Copied'; });
  }
})();
